/* APS — PDP gallery prev/next nav arrows.
   Voegt twee absoluut-gepositioneerde knoppen toe boven de loess-product-gallery
   en navigeert via gallery.changeSlide(targetSlide). */
(function () {
  'use strict';

  function svgArrow(dir) {
    var d = dir === 'prev'
      ? 'M15 18l-6-6 6-6'
      : 'M9 6l6 6-6 6';
    return (
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
        '<path d="' + d + '" stroke="currentColor" stroke-width="2.2" ' +
          'stroke-linecap="round" stroke-linejoin="round" fill="none"/>' +
      '</svg>'
    );
  }

  function getSlides(gallery) {
    return Array.prototype.filter.call(
      gallery.children,
      function (el) { return el.classList.contains('main-product__media-gallery__inner-media'); }
    );
  }

  function activeIndex(slides) {
    for (var i = 0; i < slides.length; i++) if (slides[i].hasAttribute('active')) return i;
    return 0;
  }

  function updateButtons(prevBtn, nextBtn, gallery) {
    var slides = getSlides(gallery);
    if (slides.length <= 1) {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
      return;
    }
    prevBtn.style.display = '';
    nextBtn.style.display = '';
    var idx = activeIndex(slides);
    prevBtn.disabled = idx <= 0;
    nextBtn.disabled = idx >= slides.length - 1;
  }

  function attach(wrapper) {
    if (wrapper.dataset.apsNavMounted) return;
    wrapper.dataset.apsNavMounted = '1';
    var gallery = wrapper.querySelector('loess-product-gallery');
    if (!gallery) return;

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'aps-gallery-nav aps-gallery-nav--prev';
    prev.setAttribute('aria-label', 'Vorige afbeelding');
    prev.innerHTML = svgArrow('prev');

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'aps-gallery-nav aps-gallery-nav--next';
    next.setAttribute('aria-label', 'Volgende afbeelding');
    next.innerHTML = svgArrow('next');

    function step(direction) {
      var slides = getSlides(gallery);
      if (!slides.length) return;
      var idx = activeIndex(slides);
      var newIdx = Math.max(0, Math.min(slides.length - 1, idx + direction));
      if (newIdx === idx) return;
      if (typeof gallery.changeSlide === 'function') {
        gallery.changeSlide(slides[newIdx]);
      } else {
        slides[newIdx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
      setTimeout(function () { updateButtons(prev, next, gallery); }, 50);
    }

    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });

    wrapper.appendChild(prev);
    wrapper.appendChild(next);

    // Observe attribute changes on slides voor disable/enable status
    var mo = new MutationObserver(function () { updateButtons(prev, next, gallery); });
    mo.observe(gallery, { attributes: true, subtree: true, attributeFilter: ['active'] });
    updateButtons(prev, next, gallery);
  }

  function init() {
    document.querySelectorAll('.main-product__media-gallery').forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Voor Section Rendering API (variant changes / quick view)
  document.addEventListener('shopify:section:load', init);
})();
